import { useEffect, useState } from 'react';
import Modal from './ui/Modal';
import Button from './ui/Button';
import { subscribeDialogs } from '../utils/dialogs';

// Renders the dialogs requested through utils/dialogs.js, one at a time in
// the order they were asked for. Mount once, near the app root.
export default function DialogHost() {
  const [queue, setQueue] = useState([]);

  useEffect(() => subscribeDialogs((event) => {
    if (event.type === 'open') {
      setQueue((q) => [...q, event.dialog]);
    } else if (event.type === 'closeAll') {
      setQueue((q) => { q.forEach((d) => d.resolve(false)); return []; });
    }
  }), []);

  const current = queue[0];
  if (!current) return null;

  const finish = (value) => {
    current.resolve(value);
    setQueue((q) => q.slice(1));
  };

  const isConfirm = current.kind === 'confirm';
  const title = current.title || (isConfirm ? 'Please confirm' : (current.tone === 'success' ? 'Done' : 'Notice'));

  return (
    <Modal
      open
      onClose={() => finish(isConfirm ? false : true)}
      title={title}
      footer={isConfirm ? (
        <>
          <Button variant="secondary" onClick={() => finish(false)}>{current.cancelLabel || 'Cancel'}</Button>
          <Button variant={current.danger ? 'danger' : 'primary'} onClick={() => finish(true)} autoFocus>{current.confirmLabel || 'OK'}</Button>
        </>
      ) : (
        <Button onClick={() => finish(true)} autoFocus>{current.okLabel || 'OK'}</Button>
      )}
    >
      <p style={{ margin: 0, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{current.message}</p>
    </Modal>
  );
}
